// Korean-aware text utilities.
//
// `getChosung` extracts initial consonants from Hangul syllables so users can
// search "안" with just "ㅇ". `matchName` does case-insensitive substring match
// with chosung fallback.

const CHOSUNG = "ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ";

export function getChosung(str: string): string {
  let result = "";
  for (const ch of str) {
    const code = ch.charCodeAt(0) - 0xac00;
    if (code >= 0 && code <= 11171) {
      result += CHOSUNG[Math.floor(code / 588)];
    } else {
      result += ch;
    }
  }
  return result;
}

export function matchName(name: string, query: string): boolean {
  if (!query) return true;
  const lower = (name || "").toLowerCase();
  if (lower.includes(query)) return true;
  const isChosungQuery = [...query].every((c) => CHOSUNG.includes(c));
  if (isChosungQuery) return getChosung(lower).includes(query);
  return false;
}
